module.exports = __webpack_public_path__ + "img/fenomeno.02528c88.png";